import React from 'react';
import PropTypes from 'prop-types';

import IconWithText from 'components/Widgets/IconWithText';

export default function Status({ status, className }) {
  if (!status) {
    return null;
  }

  return (
    <IconWithText
      iconClassName="dot-icon"
      iconStyle={{ minWidth: '8px', minHeight: '8px', backgroundColor: status.color }}
      contentClassName="small text-gray-800"
      wrapperClassName={`session-schedule-info ${className}`}
    >
      {status.text}
    </IconWithText>
  );
}

Status.propTypes = {
  status: PropTypes.object,
  className: PropTypes.string,
};

Status.defaultProps = {
  status: null,
  className: '',
};
